module.exports = __webpack_public_path__ + "img/Physician - Medium Gray - Selected.697451da.png";